export default {
  notVatRegistered: '30062020-074554-4024'
};
